(function ($) {
  // Document Ready
  $(document).ready(function () {
    /***************************************************
      Stat Counter Handlers
    /*****************************************************/
    if ($(".stats-section").length) {
      console.log("stat-section.js initiated");

      gsap.utils.toArray(".counter-value").forEach((el) => {
        gsap.from(el, {
          scrollTrigger: {
            trigger: el,
            start: "top 85%",
            end: "bottom top",
            once: true,
            onEnter: () => {
              $(el)
                .prop("Counter", 0)
                .animate(
                  { Counter: $(el).attr("data-count") },
                  {
                    duration: 2000,
                    easing: "linear",
                    step: function (now) {
                      $(el).text(Math.floor(now));
                    },
                    complete: function () {
                      $(el).text(this.Counter);
                    },
                  }
                );
            },
          },
        });
      });
    }
  });
})(jQuery);
